<div class="modal-header">
  <h5 class="modal-title fw-bold">
    @if (movement) {
      <i class="material-icons align-middle me-1" style="font-size: 22px;">edit</i>
      Editar movimiento
    } @else {
      <i class="material-icons align-middle me-1" style="font-size: 22px;">add_circle</i>
      Nuevo movimiento
    }
  </h5>
  <button type="button" class="btn-close" aria-label="Close"
    (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  @if (!loading) {

    <form id="formMovement" (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          <!-- Descripcion -->
          <div class="col-12 mb-3">
            <label for="description" class="form-label fw-semibold">Descripcion *</label>
            <input type="text" id="description" class="form-control"
              [(ngModel)]="description" name="description"
              placeholder="Ej: Cobro servicio - Afinacion mayor"
              [ngClass]="{ 'is-invalid': submitted && !description }">
            @if (submitted && !description) {
              <div class="invalid-feedback">Ingrese una descripcion</div>
            }
          </div>

          <!-- Notas -->
          <div class="col-12 mb-3">
            <label for="notes" class="form-label fw-semibold">Notas</label>
            <textarea id="notes" class="form-control" [(ngModel)]="notes"
              name="notes" rows="2" placeholder="Notas adicionales (opcional)"></textarea>
          </div>

          <!-- Tipo -->
          <div class="col-12 col-md-6 mb-3">
            <label class="form-label fw-semibold">Tipo de movimiento *</label>
            <ng-select [items]="movementTypes" bindLabel="label" bindValue="value"
              [(ngModel)]="movementType" name="movementType" placeholder="Seleccione tipo"
              [ngClass]="{ 'ng-invalid-custom': submitted && movementType === null }">
            </ng-select>
            @if (submitted && movementType === null) {
              <small class="text-danger">Seleccione el tipo</small>
            }
          </div>

          <!-- Estado -->
          <div class="col-12 col-md-6 mb-3">
            <label class="form-label fw-semibold">Estado *</label>
            <ng-select [items]="statusOptions" bindLabel="label" bindValue="value"
              [(ngModel)]="status" name="status" placeholder="Seleccione estado"
              [ngClass]="{ 'ng-invalid-custom': submitted && status === null }">
            </ng-select>
            @if (submitted && status === null) {
              <small class="text-danger">Seleccione el estado</small>
            }
          </div>

          <!-- Monto -->
          <div class="col-12 col-md-6 mb-3">
            <label for="amount" class="form-label fw-semibold">Monto ($) *</label>
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input type="number" id="amount" class="form-control"
                [(ngModel)]="amount" name="amount" placeholder="0.00"
                step="0.01" min="0"
                [ngClass]="{ 'is-invalid': submitted && !amount }">
            </div>
            @if (submitted && !amount) {
              <small class="text-danger">Ingrese el monto</small>
            }
          </div>

          <!-- Metodo de pago -->
          <div class="col-12 col-md-6 mb-3">
            <label class="form-label fw-semibold">Metodo de pago</label>
            <ng-select
              [items]="paymentMethods"
              bindLabel="paymentMethod"
              bindValue="idPaymentMethod"
              [(ngModel)]="idPaymentMethod"
              name="idPaymentMethod"
              placeholder="Seleccione metodo">
            </ng-select>
          </div>

          <!-- Referencia bancaria -->
          @if (showBankReference) {
            <div class="col-12 mb-3">
              <label for="bankReference" class="form-label fw-semibold">Referencia bancaria</label>
              <input type="text" id="bankReference" class="form-control"
                [(ngModel)]="bankReference" name="bankReference"
                placeholder="Ej: SPEI-78432901">
            </div>
          }

          <!-- Fecha -->
          <div class="col-12 mb-3">
            <label class="form-label fw-semibold">Fecha del movimiento</label>
            <div class="d-flex justify-content-center">
              <ngb-datepicker #dp [(ngModel)]="model"
                [ngModelOptions]="{ standalone: true }"
                (navigate)="date = $event.next">
              </ngb-datepicker>
            </div>
          </div>

          <hr class="my-2">

          <!-- Toggle factura -->
          <div class="col-12 mb-3">
            <div class="row align-items-center">
              <div class="col-8">
                <label class="form-label fw-semibold mb-0">Tiene factura?</label>
              </div>
              <div class="col-4 text-end">
                <p-inputSwitch [(ngModel)]="hasInvoice"
                  [ngModelOptions]="{ standalone: true }"></p-inputSwitch>
              </div>
            </div>
          </div>

          <!-- Upload factura PDF/XML -->
          @if (hasInvoice) {
            <div class="col-12 col-md-6 mb-3">
              <label class="form-label fw-semibold">
                <i class="material-icons align-middle text-danger me-1" style="font-size: 18px;">picture_as_pdf</i>
                Factura PDF
              </label>
              <input class="form-control" type="file" accept="application/pdf"
                (change)="onFileChange($event, 'invoicePdf')">
              @if (invoicePdfFileName) {
                <small class="text-success">
                  <i class="material-icons align-middle" style="font-size: 14px;">check_circle</i>
                  {{ invoicePdfFileName }}
                </small>
              }
            </div>

            <div class="col-12 col-md-6 mb-3">
              <label class="form-label fw-semibold">
                <i class="material-icons align-middle text-info me-1" style="font-size: 18px;">code</i>
                Factura XML
              </label>
              <input class="form-control" type="file" accept=".xml,text/xml"
                (change)="onFileChange($event, 'invoiceXml')">
              @if (invoiceXmlFileName) {
                <small class="text-success">
                  <i class="material-icons align-middle" style="font-size: 14px;">check_circle</i>
                  {{ invoiceXmlFileName }}
                </small>
              }
            </div>
          }

          <!-- Upload ticket -->
          <div class="col-12 mb-3">
            <label class="form-label fw-semibold">
              <i class="material-icons align-middle text-primary me-1" style="font-size: 18px;">receipt</i>
              Ticket / Recibo
            </label>
            <input class="form-control" type="file" accept="image/*,application/pdf"
              (change)="onFileChange($event, 'ticket')">
            @if (ticketFileName) {
              <small class="text-success">
                <i class="material-icons align-middle" style="font-size: 14px;">check_circle</i>
                {{ ticketFileName }}
              </small>
            }
          </div>

        </div>
      </div>
    </form>

  } @else {

    <div class="text-center py-4 text-secondary">
      <i class="material-icons d-block mb-2" style="font-size: 36px;">hourglass_empty</i>
      Cargando...
    </div>

  }

</div>

<div class="modal-footer">
  <div class="container-fluid">
    <div class="row g-2">
      <div class="col-6">
        <button (click)="activeModal.dismiss()" type="button"
          class="btn btn-outline-secondary w-100">Cancelar</button>
      </div>
      <div class="col-6">
        <button type="button" (click)="onSubmit()"
          [disabled]="loading"
          class="btn btn-primary w-100">
          @if (loading) {
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
          }
          {{ movement ? 'Actualizar' : 'Registrar' }}
        </button>
      </div>
    </div>
  </div>
</div>
